export enum ScoreType {
  SelfScoreComplete = 'selfscore_complete',
  SelfScoreOnScale = 'selfscore_on_scale',
  SelfScoreRubric = 'selfscore_rubric',
  AutoScore = 'autoscore',
  Opinion = 'opinion',
  Disabled = 'disabled',
}

export interface SelfScore {
  arrangementCode: string;
  contentPath: string;
}

export type SelfScoreOnScaleValue = number;

export interface SelfScoreOnScalePayload {
  score: SelfScoreOnScaleValue;
}

export interface SelfScoreOnScale extends SelfScore, SelfScoreOnScalePayload {}

export type SelfScoreRubricValue = Record<string, string>;

export interface SelfScoreRubricPayload {
  rubric: SelfScoreRubricValue;
}

export interface SelfScoreRubric extends SelfScore, SelfScoreRubricPayload {}

export type SelfScoreValue = SelfScoreOnScaleValue | SelfScoreRubricValue;

export type SelfScorePayload = SelfScoreOnScalePayload | SelfScoreRubricPayload;

export type SelfScoreType = SelfScoreOnScale | SelfScoreRubric;

export enum ScoreLevel {
  Poor = 'poor',
  Unsatisfactory = 'unsatisfactory',
  Marginal = 'marginal',
  Satisfactory = 'satisfactory',
  Excellent = 'excellent',
}

export const DEFAULT_MAX_SCORE = 100;

export const DEFAULT_SCORE_LEVELS: Array<[number, number, ScoreLevel]> = [
  [0, 40, ScoreLevel.Poor],
  [41, 50, ScoreLevel.Unsatisfactory],
  [51, 60, ScoreLevel.Marginal],
  [61, 90, ScoreLevel.Satisfactory],
  [91, 100, ScoreLevel.Excellent],
];

export const NO_SCORE_TYPES: Array<ScoreType> = [
  ScoreType.SelfScoreComplete,
  ScoreType.Opinion,
  ScoreType.Disabled,
];

export const SELF_SCORE_TYPES: Array<ScoreType> = [
  ScoreType.SelfScoreComplete,
  ScoreType.SelfScoreOnScale,
  ScoreType.SelfScoreRubric,
  ScoreType.Opinion,
];

export const getScoreBoundaries = (
  level: ScoreLevel,
  levels = DEFAULT_SCORE_LEVELS,
) => {
  const boundaries = levels.find(([, , l]) => l === level);
  return boundaries?.slice(0, 2);
};

export const getScoreLevel = (score: number, levels = DEFAULT_SCORE_LEVELS) =>
  levels.find(([min, max]) => min <= score && score <= max)?.[2];

export type scoreLabelVariant = 'default' | 'neutral';
